import { Card } from "antd";
import Visa from "../../assets/icons/Visa.svg";

const VisaCard = ({ last4, date }) => {
  return (
    <Card className="bg-gradient-to-tr from-visaBlue to-visaPurple w-24.6 h-8.7">
      <div className="flex flex-col ml-1">
        <img src={Visa} alt="Visa Icon" className="w-6 h-2 mt-1" />
        <div className="flex justify-between ">
          <p className="text-white text-base mt-0.5">Ending in **** {last4}</p>
          <p className="text-white text-base mr-1">{date}</p>
        </div>
      </div>
    </Card>
  );
};
export default VisaCard;
